module.exports = __webpack_public_path__ + "static/img/norank-bg.2cecc7e3.png";